export const BUSINESS_DOCS_CONFIG = {
  MAX_DOCS_PER_BIZ: 5,
  ACCEPTED_PDF_TYPE: "application/pdf",
};
